/**
 * 宽高比相关共享工具函数
 * 供 UploadButton.tsx 和 useFileUpload.ts 复用，避免两份比例列表不同步
 */

/** 全部支持的比例列表（15 个，含 5 个超长比例） */
export const ALL_ASPECT_RATIOS = [
  '1:1', '3:4', '4:3', '9:16', '16:9', '3:2', '2:3',
  '5:4', '4:5', '21:9', '2:1',
  '1:2', '1:3', '9:21', '3:1',
] as const;

/**
 * 根据图片/视频的实际像素宽高，匹配最接近的支持比例
 * @param width  媒体实际宽度（像素）
 * @param height 媒体实际高度（像素）
 * @returns 最接近的比例字符串（如 '9:21'），默认回退 '16:9'
 */
export const findClosestAspectRatio = (width: number, height: number): string => {
  const actualRatio = width / height;
  let closestRatio = '16:9';
  let minDiff = Infinity;
  for (const ratio of ALL_ASPECT_RATIOS) {
    const [w, h] = ratio.split(':').map(Number);
    const ratioValue = w / h;
    const diff = Math.abs(actualRatio - ratioValue);
    if (diff < minDiff) {
      minDiff = diff;
      closestRatio = ratio;
    }
  }
  return closestRatio;
};
